export const environment = { production: false, name: 'dev', apiUrl: 'https://dev.api.medicarelee.net/api' };
